module.exports = __webpack_public_path__ + "static/pattern-widget-Description-e88d16c8d25d2dd669273e8a3e065f79.png";